export default class EnterpriseInfoController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/enterpriseInfo/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/enterpriseInfo/view', 'get', params, axiosOption, httpOption);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/enterpriseInfo/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/enterpriseInfo/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/enterpriseInfo/delete', 'post', params, axiosOption, httpOption);
  }

  static importData (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/enterpriseInfo/import', 'post', params, axiosOption, httpOption);
  }
}
